import { addQueryParams } from './addQueryParams';
const ALLOWED_FORWARD_QUERY_PARAMS = ['funnelSessionId', 'category', 'category_adi_search', 'businessName', 'domain', 'logo', 'siteCreationFolderId', 'ref', 'http_referrer'];

/**
 * Builds a redirect URL by automatically forwarding allowed query params
 * @param targetUrl - The URL where forwarding allowed query params will be added
 * @param queryParams - The query params to forward, skip to forward the current URL query params (browser)
 */
export const forwardFunnelQueryParams = (targetUrl, queryParams) => {
  if (!queryParams && typeof window !== 'undefined' && window.location) {
    queryParams = Object.fromEntries(new URLSearchParams(window.location.search));
  }
  const queryParamsToForward = Object.fromEntries(Object.entries(queryParams || {}).filter(_ref => {
    let key = _ref[0];
    return ALLOWED_FORWARD_QUERY_PARAMS.includes(key);
  }));
  return addQueryParams(targetUrl, queryParamsToForward, {
    override: false
  });
};
//# sourceMappingURL=forwardFunnelQueryParams.js.map